import { Item } from '@react-stately/collections'
import { ArrowRotateLeft2 } from 'blaze-ui/icons'
import Images from 'blaze-ui/icons/20/Images'
import { Menu } from 'components/Menu/Menu'
import { Key } from 'react'
import { openImageReplacePrompt } from '../../../openImageReplacePrompt'
import { EditorView } from 'prosemirror-view'
import { schema } from 'prose-core'
import { ImageNodeAttrs } from '../../../Types'
import { Unsplash } from 'proseShared/IntegrationsIcons'
import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { replaceImageWithImages } from '../../../utils'
import { useModals } from 'almanac-ui/Modal'

interface Props {
  view: EditorView<typeof schema>
  attrs: ImageNodeAttrs
  onAction?: (key: Key) => any
}

export const QuickActionsMenu = ({ view, attrs, onAction }: Props) => {
  const unsplashQuery = useUnsplashImages(
    {
      queryKey: ['unsplashImages', 'alternative', attrs.blockId],
      query: attrs.unsplashQuery || '',
    },
    { enabled: false },
  )
  const stackManager = useModals()

  const handleAction = async (key: Key) => {
    if (key === 'auto') {
      const query = await unsplashQuery.refetch()
      const results = query.data?.pages.flatMap((page) => (page.type === 'success' ? page.data.results : [])) ?? []
      if (results.length === 0) {
        showErrorMessageToast('Could not find a replacement image.')
        return
      }

      const currentPhotoIndex = results.findIndex((photo) => photo.id === attrs.unsplashId)
      const newPhotoIndex = (currentPhotoIndex + 1) % results.length
      const photo = results[newPhotoIndex]
      if (!photo || photo.id === attrs.unsplashId) {
        showErrorMessageToast('Could not find a replacement image.')
        return
      }

      replaceImageWithImages(view, attrs, [
        {
          url: photo.urls.regular,
          unsplash: {
            authorUsername: photo.user.username,
            authorName: photo.user.name,
            id: photo.id,
            query: attrs.unsplashQuery || '',
          },
        },
      ])
    }

    if (key === 'pick') {
      openImageReplacePrompt(view, attrs, {
        initialQuery: attrs.unsplashQuery || '',
        preselectedIntegration: Unsplash,
        stackManager,
      })
    }

    onAction?.(key)
  }

  return (
    <Menu aria-label="Quick actions" onAction={handleAction}>
      {attrs.unsplashQuery && (
        <Item key="auto" textValue="Try Different Image">
          <ArrowRotateLeft2 /> Try Different Image
        </Item>
      )}

      <Item key="pick" textValue="Pick Image">
        <Images /> Pick Image
      </Item>
    </Menu>
  )
}
